import MyGanttRenderer from 'core/renderers/MyGanttRenderer';
import { Tracer } from 'core/tracers';
import * as _ from 'lodash';


class MyGanttTracer extends Tracer {
  getRendererClass() {
    return MyGanttRenderer;
  }

  set(tasks = [], rowId = 0) {
    this.data = this.data || {}
    if(!this.data.tasks) this.data.tasks = [tasks]
    else this.data.tasks[rowId] = tasks;
    super.set();
  }

  setAmountOfSteps(steps){
    this.data.steps = steps;
  }

  setAmountOfRows(rowCount) {
    if(!this.data.tasks) this.data.tasks = Array.from({length: rowCount}, () => []);
    else {
      const rowsToAdd = Math.max(0, rowCount - this.data.tasks.length);
      if(rowsToAdd > 0) this.data.tasks.push(...Array.from({length: rowsToAdd}, () => []));
    }
  }

  setTimeScale(timeScale){
    this.data.timeScale = timeScale;
  }

  setTickMarks(tickMarks){
    this.data.tickMarks = tickMarks;
  }

  setLabels(rowLabels, colLabel){
    this.data.rowLabels = rowLabels;
    this.data.colLabel = colLabel;
  }

  patch(taskIds) {
    const ids = this.data.highlightedTasks || [];
    ids.push(...taskIds);
    this.data.highlightedTasks = ids;
  }

  depatch(taskIds) {
    const ids = this.data.highlightedTasks || [];
    this.data.highlightedTasks = _(ids).without(...taskIds).value();
  }
  
}

export default MyGanttTracer;
